import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS, SUPPORTED_PAGES } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "product-grid",
  label: "Product Grid",
  description: "A product grid section with multiple layout variants.",
  supportedPages: ["home", "category", "categories", "shop"] as typeof SUPPORTED_PAGES[number][],
  variants: [
    {
      id: "v1",
      label: "V1 — 4-Col Standard Grid (Fashion)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "All Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Customer Favorite Style" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
      ],
    },
    {
      id: "v2",
      label: "V2 — Featured + List Aside (Week's Featured)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Week's Featured" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Top Picks" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
      ],
    },
    {
      id: "v3",
      label: "V3 — Electronics List View + Sidebar",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Trending Products" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Electronics" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
      ],
    },
    {
      id: "v4",
      label: "V4 — Gadget Showcase (1 Large + Smaller Cards)",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Top Gadgets" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "New Arrivals" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
      ],
    },
    {
      id: "v5",
      label: "V5 — Beauty 4-Col Image-Focused",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Beauty Essentials" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Trending Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
      ],
    },
    {
      id: "v6",
      label: "V6 — Trending List + Special Offer with Countdown",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "This Week's Picks" },
        { key: "subtitle", label: "Subtitle / Label", type: "string", default: "Hot Right Now" },
        { key: "viewAllLink", label: "View All Link", type: "string", default: "/shop" },
        { key: "offerEndsAt", label: "Offer End Date (ISO string)", type: "string" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
